import { Pressable, Text, View } from "react-native";
import { FloorModel } from "../../../services/api/types/locations/models/FloorModel";
import clsx from "clsx";
import { useRef, useState } from "react";
import { Icon, ThreeDotsIcon } from "ui/gluestack/icon";
import { ActionPopupMenu } from "../../../components/molecules/ActionPopupMenu";
interface Props {
  floor: FloorModel & { startEditing?: boolean };
  onFloorSelected: (floor: FloorModel) => void;
  currentSelectedFloor?: number;
  onEditFloor: (floor: FloorModel) => void;
  onDeleteFloor: () => void;
}

export function EditableFormFloorDetails({
  floor,
  currentSelectedFloor,
  onFloorSelected,
  onEditFloor,
  onDeleteFloor,
}: Props) {
  const [showMenu, setShowMenu] = useState(false);
  const menuIconRef = useRef<View>(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });

  const openMenu = () => {
    menuIconRef.current?.measure((_fx, _fy, _width, height, px, py) => {
      setMenuPosition({ top: py + height, left: px });
      setShowMenu(true);
    });
  };

  const handleClose = () => {
    setShowMenu(false);
  };

  const menuActions = [
    { title: "Edit floor details", onPress: () => onEditFloor(floor) },
    { title: "Delete floor", onPress: onDeleteFloor },
  ];

  const handleFloorSelected = () => {
    onFloorSelected(floor);
  };

  return (
    <Pressable
      onPress={handleFloorSelected}
      onLongPress={() => onEditFloor(floor)}
      className={clsx(
        "flex-1 flex-row py-4 pl-4 m-2 rounded-sm",
        floor.id === currentSelectedFloor && floor.id !== undefined
          ? "bg-secondary-0"
          : "bg-transparent",
      )}
    >
      <View className="flex-1 mr-5">
        <View className="flex lg:flex-row justify-between gap-x-3 mb-3">
          <Text className="font-semibold">{floor.name}</Text>
          <Text>{floor.floor_number}</Text>
        </View>
        <Text>{floor.description}</Text>
      </View>

      <Pressable ref={menuIconRef} onPress={openMenu}>
        <Icon as={ThreeDotsIcon} className="rotate-90" />
      </Pressable>

      <ActionPopupMenu
        visible={showMenu}
        onClose={handleClose}
        position={menuPosition}
        actions={menuActions}
      />
    </Pressable>
  );
}
